// react
import { useState } from 'react';

// types
import { LoadingStatus } from '../@types';

export const useLearningHub = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// state
	const [statusGetLearningHub, setGetLearningHubStatus] = useState<LoadingStatus>('DEFAULT');

	const handleClickLearningHub = async () => {
		setGetLearningHubStatus('LOADING');

		try {
			const reqGetLessons = await fetch(
				`${process.env.REACT_APP_API_URL}/lessons/content/index.html`,
				{
					method: 'GET',
					headers: {
						Authorization: `Bearer ${accessToken}`,
						User: String(idToken),
					},
				}
			);

			if (!reqGetLessons.ok) {
				throw new Error(`${reqGetLessons.status}: ${await reqGetLessons.text()}`);
			}

			const html = await reqGetLessons.text();

			// open window synchronously while still in the user gesture context
			const newWindow = window.open('', '_blank');

			if (html && newWindow) {
				const blob = new Blob([html], { type: 'text/html' });
				const url = URL.createObjectURL(blob);

				newWindow.location.href = url;
				URL.revokeObjectURL(url);
			} else {
				newWindow?.close();
				throw new Error('Failed to load lessons content');
			}
		} catch (error) {
			console.error(error);
		} finally {
			setGetLearningHubStatus('DEFAULT');
		}
	};

	return {
		handleClickLearningHub,
		statusGetLearningHub,
	};
};
